import React, { useEffect, useContext } from "react";

// Context
import AppContext from "./AppContext";

// Css
import "./SmallBar.css";

//Components
import SmallTools from "./SmallTools";
import ColorBar from "./ColorBar";

// Material Ui
// #Transitions
import Zoom from "@material-ui/core/Zoom";

function Smallbar() {
  const { appContext, setAppContext } = useContext(AppContext);
  const { textFocus } = appContext;
  return (
    <>
      <Zoom in={textFocus} style={{ transitionDuration: "0.7s" }}>
        <div className="smallbar">
          <SmallTools />
        </div>
      </Zoom>
    </>
  );
}

export default Smallbar;
